<template>
    <div class="single-addition-wrapper">
        <div class="category-wrapper">
            <div class="category-box">
                <div class="category-title">企业类目</div>
                <div class="category-search flex">
                    <el-input v-model="filterText" placeholder="输入类别名称或编码" class="input-box" suffix-icon="el-icon-search"></el-input>
                    <div class="select-box">查询</div>
                </div>
                <div class="category-btn padding-10">
<!--                    v-permission="['/product/purchaseCategory/addCategory']"-->
                    <div class="btn-item flex-sc" >
                        <div @click="handleAdd('add')"  >
                            <img src="../../../../../assets/img/common/add.png" alt="">
                            <span >新建</span>
                        </div>
                        <el-tooltip class="item" effect="dark" placement="top">
                            <template v-slot:content>
                                1.直接点击“新建”，增加新的一级类目；<br>
                                2.选中一级（二级）类目，点击“新建”，在其下增加二级（三级）类目；<br>
                                3.三级类目是最末级类目，不允许再建下级类目。<br>
                                4.点击选中企业类目，双击取消选中。
                            </template>
                            <div class="empty-mark"></div>
                        </el-tooltip>
                    </div>
<!--                    v-permission="['/product/purchaseCategory/modifyCategory']"-->
                    <div class="btn-item flex-sc" >
                        <div @click="handleEdit('edit')" >
                            <img src="../../../../../assets/img/common/edit.png" alt="">
                            <span >编辑</span>
                        </div>
                        <el-tooltip class="item" effect="dark" placement="top">
                            <template v-slot:content>
                                1. 选中类别树层级，点击“编辑”，编辑本类目；<br>
                                2. 编辑三级类目时，可调整映射的末级平台类目。
                            </template>
                            <div class="empty-mark"></div>
                        </el-tooltip>
                    </div>
<!--                    v-permission="['/product/purchaseCategory/removeCategory']"-->
                    <div class="btn-item flex-sc" @click="deleteCategory"  >
                        <img src="../../../../../assets/img/common/del.png" alt="">
                        <span >删除</span>
                    </div>
                </div>
                <div class="category-tree category-tree-height">
                    <el-tree
                            :data="enterpriseCategoryData"
                            node-key="id"
                            ref="enterpriseTree"
                            highlight-current
                            :current-node-key="current"
                            :props="defaultProps"
                            @node-click="nodeClick"
                            :filter-node-method="filterNode"
                            :default-expanded-keys="enterpriseDefaultExpand">
                        <div slot-scope="{ node, data }" class="tree-box">
                            <e-tooltip :content="data.code ? (data.code +'-'+ data.name) :data.name" :setLength="14" class="name-box"/>
<!--                            v-permission="['/product/purchaseCategory/moveUp']"-->
<!--                            v-permission="['/product/purchaseCategory/moveDown']"-->
                            <div>
                                <span @click.stop="handleUp(node, data)" class="margin-r20" >上移</span>
                                <span @click.stop="handleDown(node, data)" >下移</span>
                            </div>
                        </div>
                    </el-tree>
                </div>
            </div>
            <div class="category-box">
                <div class="category-title">企业类目详细信息</div>
                <div v-show="handleTypeFlag">
                    <div class="category-detail">
                        <el-form :model="formData" :label-width="clickCategoryTreeData.level === 1 && handleTypeFlag !== 'add'? '122px' : '176px'"
                                 :rules="handleTypeFlag === 'show' ? {} : rules" ref="ruleForm" :key="handleTypeFlag">
                            <el-form-item :label="handleTypeFlag === 'add' ? '新增分类名称：' :'本级分类名称：'" prop="name"  :style="{ 'margin-bottom': handleTypeFlag === 'show' ? '0' : '20px' }">
                                <e-tooltip :content="clickCategoryTreeData.name" :setLength="16" class="name-box"
                                           v-if="handleTypeFlag === 'show'" />
                                <el-input v-model="formData.name" class="detail-input" placeholder="请输入" style="height: 30px;" max-length="20"
                                          v-else></el-input>
                            </el-form-item>
                            <el-form-item :label="handleTypeFlag === 'add' ? '新增分类代码：' :'本级分类代码：'" :style="{ 'margin-bottom': handleTypeFlag === 'show' ? '0' : '20px' }">
                                <div v-if="handleTypeFlag === 'show'" style="margin-bottom: 0">{{clickCategoryTreeData.code}}</div>
                                <el-input v-model="formData.code" class="detail-input" placeholder="请输入" style="height: 30px;"
                                          max-length="30"  v-else></el-input>
                            </el-form-item>
                            <el-form-item label="本级分类级别：" style="margin-bottom: 0" v-if="handleTypeFlag === 'show'">
                                <div>{{clickCategoryTreeData.level}} </div>
                            </el-form-item>
                            <div v-if="clickCategoryTreeData.level === 3 || (clickCategoryTreeData.level === 2 && handleTypeFlag === 'add') ">
                                <el-form-item label="上级分类名称（二级）：" style="margin-bottom: 0">
                                    <e-tooltip :content="clickCategoryTreeData.upTwoName" :setLength="16" class="name-box" />
                                </el-form-item>
                                <el-form-item label="上级分类代码（二级）：" style="margin-bottom: 0">
                                    <div>{{clickCategoryTreeData.upTwoCode}} </div>
                                </el-form-item>
                            </div>
                            <div v-if="clickCategoryTreeData.level === 2 || clickCategoryTreeData.level === 3 ||
                                            (clickCategoryTreeData.id && handleTypeFlag === 'add') ">
                                <el-form-item label="上级分类名称（一级）：" style="margin-bottom: 0">
                                    <e-tooltip :content="clickCategoryTreeData.upOneName" :setLength="16" class="name-box" />
                                </el-form-item>
                                <el-form-item label="上级分类代码（一级）：" style="margin-bottom: 0">
                                    <div>{{clickCategoryTreeData.upOneCode}} </div>
                                </el-form-item>
                            </div>
                        </el-form>
                    </div>
                    <div class="category-search flex-c margin-t10" style="padding-top: 0" v-if="handleTypeFlag === 'add' || handleTypeFlag === 'edit'">
                        <div class="select-box" @click="handleCancle">取 消</div>
                        <div class="select-box save-btn" @click="handleSave">保 存</div>
                    </div>
                </div>
                <div v-if="handleTypeFlag">
                    <div class="category-title margin-t10" style="border-top: 1px solid #D9D9D9">映射的平台类目</div>
                    <div class="category-data">
                        <div v-for="(item,index) in checkCategoryData" :key="index" >
                            <div class="category-name">{{item.categoryName}}</div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="category-box">
                <div class="category-title">平台类目</div>
                <div class="category-search flex">
                    <el-input v-model="platformSearchText" placeholder="输入类别名称" class="input-box" suffix-icon="el-icon-search"></el-input>
                    <div class="select-box">查询</div>
                </div>
                <div class="category-tree">
                    <el-tree
                            :data="platformCategoryData"
                            :show-checkbox="showCheckbox"
                            node-key="categoryId"
                            class="tree-wrapper"
                            res="nodeTree"
                            ref="elTree"
                            :props="defaultProps"
                            :default-checked-keys="defaultCheckedKeys"
                            @check="getCheckedNodes"
                            :filter-node-method="platformFilterNode">
                    </el-tree>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
    import api from '@/modules/projectA/api/purchase';
    import productApi from '@/modules/projectA/api/product';
    import eTooltip from '../../../components/common/e-tooltip.vue'

    export default {
        name: "singleAddition",
        components: {eTooltip},
        data() {
            return {
                rules: {
                    name: [{required: true, message: '本级分类名称不能为空', trigger: 'change'}],
                },
                clickCategoryTreeData: {},//企业类目树点击 存储的数据
                clickCategoryTreeNode:{},//
                checkCategoryData:[],//企业类目树点击 存储的name节点
                categoryExistRelData:[],//已被关联，不可勾选的平台类目分类
                formData: {
                    name: '',//名称
                    level: '',//分类等级
                    code: '',//分类编码
                    id:'',//用于编辑
                    parentId: null,//上级id，二三级用
                    categoryIdList:[],//关联的 平台类目 id 集合
                },
                disabled: true,
                categoryData: ['企业类目', '企业类目详细信息', '平台类目'],
                current:null,
                enterpriseCategoryData: [],//企业类目树
                enterpriseDefaultExpand:[],//企业类目 默认展开
                showCheckbox:false,//平台类目树只有点击第三级才可选中
                platformCategoryData: [],//平台类目树
                platformCategoryDataCopy :[],//备份只有末级可以选中的数据，防止多次调用
                checkPlatformCategoryData:[],//勾选的 平台类目
                defaultCheckedKeys:[],//平台类目默认选中
                defaultProps: {
                    label: 'categoryName',
                },
                handleTypeFlag: null,//操作类型   show、add、edit
                filterText: '',
                platformSearchText:'',
            }
        },
        methods: {
            //企业类目树 搜索
            filterNode(value, data) {
                if (!value) return true;
                return data.name.indexOf(value) !== -1 ||  data.code.indexOf(value) !== -1
            },
            //企业类目树 搜索
            platformFilterNode(value, data) {
                if (!value) return true;
                return data.categoryName.indexOf(value) !== -1
            },
            //点击平台类目树
            getCheckedNodes(val,nodes){
                this.checkCategoryData = nodes.checkedNodes.filter(item=> item.categoryLevel === 3 || item.categoryLevel === 4 );
                this.formData.categoryIdList =  this.checkCategoryData.map(item=>item.categoryId) ;
            },

            //保存
            handleSave() {
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        if (this.handleTypeFlag === 'add') {//增加
                            this.purchaseAddCategory();
                        } else if (this.handleTypeFlag === 'edit') {//编辑
                            this.purchaseModifyCategory();
                        }
                    }
                })
            },
            //增加
            purchaseAddCategory() {
                api.purchaseAddCategory(this.formData).then(res => {
                    if (res.success) {
                        this.$message.success('保存成功。')
                        this.handleCommon();
                    }
                });
            },
            //编辑
            purchaseModifyCategory() {
                api.purchaseModifyCategory(this.formData).then(res => {
                    if (res.success) {
                        this.$message.success('保存成功。')
                        this.handleCommon();
                    }
                });
            },
            //增加和编辑成功 公共部分
            handleCommon(){
                this.queryPurchaseCategoryTree();
                if(this.clickCategoryTreeNode.hasOwnProperty("data")){
                    this.enterpriseDefaultExpand = [this.clickCategoryTreeNode.data.id] ;
                }
                this.clickCategoryTreeData.name = this.formData.name;
                this.clickCategoryTreeData.code = this.formData.code;
                this.handleTypeFlag = 'show';
                this.showCheckbox = false;
                this.currentKeyShow();
            },
            //默认回显
            currentKeyShow(){
                if(this.clickCategoryTreeNode.hasOwnProperty("data")){
                    this.current = this.clickCategoryTreeNode.data.id;
                    setTimeout(() => {
                        this.$nextTick(() => {
                            this.$refs.enterpriseTree.setCurrentKey(Number(this.current)); //一定要加这个选中了否则样式没有出来
                        });
                    }, 300)
                }
            },
            //上移
            handleUp(node, data) {
                api.purchaseCategoryMoveUp({id: data.id}).then(res => {
                    if (res.success) {
                        this.queryPurchaseCategoryTree();
                    }
                });
            },
            //下移
            handleDown(node, data) {
                api.purchaseCategoryMoveDown({id: data.id}).then(res => {
                    if (res.success) {
                        this.queryPurchaseCategoryTree();
                    }
                });
            },
            //取消
            handleCancle() {
                this.$refs['ruleForm'].resetFields();
                this.handleTypeFlag = null;
                this.formData = {
                    name: '',//名称
                    level: '',//分类等级
                    code: '',//分类编码
                    id:'',//用于编辑
                    parentId: null,//上级id，二三级用
                    categoryIdList:[],//关联的 平台类目 id 集合
                }
                this.clickCategoryTreeData = {};
                this.clickCategoryTreeNode= {};
                this.showCheckbox = false;
                setTimeout(() => {
                    this.$nextTick(() => {
                        this.$refs.enterpriseTree.setCurrentKey(); //一定要加这个选中了否则样式没有出来
                    });
                }, 300)
            },
            //新增
            handleAdd(type){
                if(this.clickCategoryTreeData.hasOwnProperty("level") && this.clickCategoryTreeData.level === 3){
                    this.$message.warning('已是末级类目。');
                    return false;
                }
                this.handleTypeFlag = type;
                //新增时没有点击 即新增新的一级
                if(!this.clickCategoryTreeData.hasOwnProperty("id")){
                    this.clickCategoryTreeData.level = 1;
                    this.formData.level = 1;
                    this.formData.name = '';
                    this.formData.code = '';
                }else{
                    this.formData.name = '';
                    this.formData.code = '';
                }
                if(this.clickCategoryTreeData.level === 2){
                    this.showCheckbox = true;
                }else{
                    this.showCheckbox = false;
                }

                //没有点击 新增 三 级
                if( this.clickCategoryTreeData.level === 2){
                    this.$set(this.clickCategoryTreeData,'upOneName',this.clickCategoryTreeNode.parent.data.name);
                    this.$set(this.clickCategoryTreeData,'upOneCode',this.clickCategoryTreeNode.parent.data.code);
                    this.$set(this.clickCategoryTreeData,'upTwoName',this.clickCategoryTreeData.name);
                    this.$set(this.clickCategoryTreeData,'upTwoCode',this.clickCategoryTreeData.code);
                }
                //没有点击 新增 二 级
                if ( this.clickCategoryTreeData.level === 1 ){
                    this.$set(this.clickCategoryTreeData,'upOneName',this.clickCategoryTreeData.name);
                    this.$set(this.clickCategoryTreeData,'upOneCode',this.clickCategoryTreeData.code);
                }

                //点击新增 第二级 查询 默认不能勾选的平台类目
                //已被关联，不可勾选的平台类目分类
                this.purchaseCategoryExistRel();
            },

            handleEdit(type) {
                if (this.judgeClickTree()) {
                    return false;
                }
                this.handleTypeFlag = type;
                //回显编辑的数据
                this.formData.name = this.clickCategoryTreeData.name;
                this.formData.code = this.clickCategoryTreeData.code;
                this.formData.level = this.clickCategoryTreeData.level;
                this.formData.id = this.clickCategoryTreeData.id;

                if(this.clickCategoryTreeData.level === 3){
                    this.showCheckbox = true;
                }else{
                    this.showCheckbox = false;
                }
            },
            //删除树
            deleteCategory() {
                if (this.judgeClickTree()) {
                    return false;
                }
                this.$confirm('将删除该导购分类及其下末级分类与平台分类映射关系，并清除列表对应内容。', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    api.purchaseRemoveCategory({id: this.clickCategoryTreeData.id}).then(res => {
                        if (res.success) {
                            this.queryPurchaseCategoryTree();
                            if(this.clickCategoryTreeNode.hasOwnProperty("parent")){
                                this.enterpriseDefaultExpand = [this.clickCategoryTreeNode.parent.data.id] ;
                            }
                        }
                    });
                })
            },
            //判断是否点击tree true没有点击  false 点击了
            judgeClickTree() {
                if (this.enterpriseCategoryData.length === 0) {
                    this.$message.warning('您尚未建立企业类目，请点击新建按钮进行类目创建。');
                    return true;
                }
                if (!this.clickCategoryTreeData.id) {
                    this.$message.warning('请选中类目后操作。');
                    return true;
                }
                return false;
            },
            // 点击树 企业类目树
            nodeClick(data, node) {
                let nodeLen =  Object.keys(this.clickCategoryTreeData).length;
                if(nodeLen === 0 || this.clickCategoryTreeData.id !== data.id){
                    this.checkCategoryData = [];
                    this.formData.categoryIdList = [];
                    this.clickCategoryTreeData = data;
                    this.clickCategoryTreeNode = node;

                    //处理点击数据 企业类目详细信息
                    this.dealClickData();
                    //获取映射的平台类目  第三级
                    if(this.clickCategoryTreeData.level !== 1){
                        this.clearCheck();
                        this.purchaseCategoryRel();
                        // console.log('2222')
                    }
                    this.showCheckbox = false;
                }else if(this.clickCategoryTreeData.id === data.id){//双刺点击取消选中
                    this.handleCancle();
                }
            },
            //清空默认选中
            clearCheck(){
                // console.log('111111111')
                this.defaultCheckedKeys = [];
                this.checkCategoryData = [];
                this.$refs.elTree.setCheckedKeys([]);
            },
            //处理点击数据 企业类目详细信息  新增编辑
            dealClickData() {
                this.handleTypeFlag = 'show';//只是展示
                //点选了树 新增就是有上一级父节点
                this.formData.parentId = this.clickCategoryTreeData.id;
                this.formData.level = this.clickCategoryTreeData.level + 1;
                //三级
                if( this.clickCategoryTreeData.level === 3){
                    this.$set(this.clickCategoryTreeData,'upTwoName',this.clickCategoryTreeNode.parent.data.name);
                    this.$set(this.clickCategoryTreeData,'upTwoCode',this.clickCategoryTreeNode.parent.data.code);
                    this.$set(this.clickCategoryTreeData,'upOneName',this.clickCategoryTreeNode.parent.parent.data.name);
                    this.$set(this.clickCategoryTreeData,'upOneCode',this.clickCategoryTreeNode.parent.parent.data.code);
                }
                //二级
                if ( this.clickCategoryTreeData.level === 2 ){
                    this.$set(this.clickCategoryTreeData,'upOneName',this.clickCategoryTreeNode.parent.data.name);
                    this.$set(this.clickCategoryTreeData,'upOneCode',this.clickCategoryTreeNode.parent.data.code);
                }
            },
            //获取映射的平台类目
            async purchaseCategoryRel() {
                await api.purchaseCategoryRel({id: this.clickCategoryTreeData.id}).then(res => {
                    if (res.success && res.data.length > 0 ) {
                        this.defaultCheckedKeys = res.data.map(item=>item.categoryId);
                        this.checkCategoryData = res.data;
                    }
                    //已被关联，不可勾选的平台类目分类
                    this.purchaseCategoryExistRel();
                });
            },
            //已被关联，不可勾选的平台类目分类
            async purchaseCategoryExistRel(){
                let params = {};
                if(this.clickCategoryTreeData.level === 3){
                    params.id = this.clickCategoryTreeData.id;
                }
                await  api.purchaseCategoryExistRel(params).then(res => {
                    if (res.success) {
                        this.categoryExistRelData = res.data || [];
                        this.platformCategoryData = this.platformCategoryDataCopy;
                        this.formatData(this.platformCategoryData);
                    }
                });
            },
            //获取企业类目 树
            queryPurchaseCategoryTree() {
                api.queryPurchaseCategoryTree().then(res => {
                    if (res.success) {
                        this.enterpriseCategoryData = res.data || [];
                        if (this.enterpriseCategoryData.length === 0) {
                            this.formData.level = '01';//设置分类等级
                            this.clickCategoryTreeData = {};
                            this.clickCategoryTreeNode= {};
                        }
                    }
                });
            },
            //获取 平台类目 树
            usefulCategoryTree() {
                productApi.usefulCategoryTree().then(res => {
                    if (res.success) {
                        this.platformCategoryData = res.data || [];
                        //最末级节点才可以选中
                        this.formatData(this.platformCategoryData);
                        //备份只有末级可以选中的数据
                        this.platformCategoryDataCopy = JSON.parse(JSON.stringify(this.platformCategoryData ));
                    }
                });
            },
            //最末级节点 才可以选中
            formatData(params) {
                let data = params;
                data.map(item => {
                    //已被关联，不可勾选的
                    if(!item.hasOwnProperty("children")){
                        if(this.categoryExistRelData.length > 0 && this.categoryExistRelData.includes(item.categoryId)){
                            item.disabled = true;
                        }else{
                            item.disabled = false;
                        }
                    }

                    if (item.hasOwnProperty("children") && item.children.length !== 0 ) {
                        // 只有要children属性就禁止选择 需要修改css 代码
                        item.disabled = true;
                        // 递归调用 直到没有 children 属性那级
                        this.formatData(item.children);
                    }

                });
                return data;
            },
        },
        mounted() {
            this.queryPurchaseCategoryTree();//企业类目
            this.usefulCategoryTree();//平台类目

        },
        watch: {
            filterText(val) {
                this.$refs.enterpriseTree.filter(val);
            },
            platformSearchText(val) {
                this.$refs.elTree.filter(val);
            }

        },
    }
</script>

<style scoped lang="scss">
    .single-addition-wrapper {
        width: 100%;

        .category-wrapper {
            display: flex;

            .category-box {
                flex: 1;
                height: 586px;
                border: 1px solid #D9D9D9;
                border-right: none;
                background: #FFF;

                &:last-child {
                    border-right: 1px solid #D9D9D9;
                }

                .category-title {
                    text-align: center;
                    height: 40px;
                    line-height: 40px;
                    background: #F5F5F5;
                    font-weight: 500;
                    border-bottom: 1px solid #D9D9D9;
                }

                .category-search {
                    padding: 10px;

                    .input-box {
                        width: 90%;
                        height: 30px;
                    }

                    .select-box {
                        margin-left: 10px;
                        width: 60px;
                        height: 30px;
                        line-height: 30px;
                        text-align: center;
                        border: 1px solid #2587FF;
                        color: #2587FF;
                        background: #FFF;
                        cursor: pointer;
                        font-size: 14px;

                        &:hover {
                            color: #FFF;
                            background: #2587FF;
                        }
                    }

                    .save-btn {
                        background-color: #2587FF;
                        color: #FFF;

                        &:hover {
                            background-color: #126edf;
                        }
                    }
                }

                .category-btn {
                    color: #2587FF;
                    display: flex;
                    margin: 0 10px;
                    justify-content: space-between;
                    border-bottom: 1px solid #D9D9D9;

                    .btn-item {
                        padding-bottom: 10px;

                        img {
                            width: 16px;
                            height: 16px;
                            margin-right: 6px;
                        }
                        span{
                            &:hover{
                                color: #0064c8;
                            }
                        }

                        .empty-mark {
                            margin-left: 6px;
                            background: url("../../../../../assets/img/common/query-empty-mark.png") no-repeat;
                            background-size: 14px 14px;
                            width: 14px;
                            height: 14px;

                            &:hover {
                                background-image: url("../../../../../assets/img/common/real-mark.png");
                            }
                        }

                        &:hover {
                            cursor: pointer;
                        }
                    }
                }

                .category-tree {
                    height: 80%;
                    overflow-y: auto;
                    ::v-deep  .el-tree-node__content:hover{
                        color: #2587FF;
                    }
                    .tree-box {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        width: 100%;
                        padding-right: 10px;
                        .name-box {
                            font-weight: 350;
                            font-size: 14px;
                            color: #333;
                        }
                        span{
                            font-weight: 350;
                            font-size: 12px;
                            color: #999;
                            &:hover{
                                color: #2587FF;
                            }
                        }
                    }
                }
                .category-tree-height{
                    height: 76%;
                }
                .category-detail {
                    margin-top: 10px;
                    height: 70%;

                    .detail-input {
                        width: 90%;
                        height: 30px;
                    }
                }

                .category-data{
                    padding-left: 10px;
                    height: 160px;
                    overflow-y: auto;
                    .category-name{
                        font-weight: 350;
                        font-size: 14px;
                        color: #333;
                        margin-top: 10px;
                    }
                }

            }

            .border-right {
                border-right: 1px solid #D9D9D9;
            }
        }
    }

</style>